import { applyMiddleware, compose, createStore as create } from 'redux';
import createRootReducer from './createRootReducer';
import middleware from './middleware';
import { ACTION_TYPES } from '../../constants';

/**
 *  Function to dispatch the page load action if we are client-side
 */
export function maybeDispatchPageLoad(store, pageName) {
    if (typeof window !== 'undefined') {
        store.dispatch({
            type: ACTION_TYPES.PAGE_LOAD,
            pageName,
        });
    }
}

export default function createStore(options = {}) {
    const {
        initialState = {},
        reducers = {},
        preGaCustomMiddleware = [],
        postGaCustomMiddleware = [],
        pageName,
        isStorybook = false,
    } = options;

    const enhancers =
        typeof window !== 'undefined' && window.devToolsExtension
            ? [window.devToolsExtension()]
            : [];

    const store = create(
        createRootReducer(reducers, isStorybook),
        initialState,
        compose(
            applyMiddleware(
                ...preGaCustomMiddleware,
                ...middleware(pageName),
                ...postGaCustomMiddleware
            ),
            ...enhancers
        )
    );

    maybeDispatchPageLoad(store, pageName);

    return store;
}
